(function () {
    'use strict';

    angular.module('swif.openbase')
        .factory('swifOpenbaseCustomFieldsService', swifOpenbaseCustomFieldsService)
        .directive('customFieldsDirective', customFieldsDirective)
        .controller('customFieldsTemplateController', customFieldsTemplateController);


    /**
     * @ngdoc service
     * @name swif.openbase.swifOpenbaseCustomFieldsService
     * @description custom_fields manager
     **/
    function swifOpenbaseCustomFieldsService(swif) {
        'ngInject';
        var service = {};

        service.removeField = function (custom_fields, currentField) {
            custom_fields.splice(_.indexOf(custom_fields,currentField),1);
        }
        
        service.addField = function (custom_fields) {
            custom_fields.push({key:false, type:false, value:false});
        }

        // check keys unicity, and prevent validation in case of key duplication
        service.onChange = function (scope, currentField) {
            var fields = scope.item;
            _.forEach(fields, function (field) {
                field._invalidKey = false;
            });
            _.forEach(fields, function (field) {
                if (field.key === currentField.key && _.indexOf(fields, field) !== _.indexOf(fields, currentField)) {
                    scope.form.$invalid = true;
                    field._invalidKey = true;
                    currentField._invalidKey = true;
                }
            });
        }
        service.onTypeChange = function (currentField) {
            currentField.value = false;
        }

        service.getCustomFieldsTypes = function () {
            return [
                {id: 'text', name: 'Chaine de caractères'},
                {id: 'number', name: 'Numérique'},
                {id: 'price', name: 'Prix'},
                {id: 'date', name: 'Date'},
                {id: 'bool', name: 'Booléen'}
            ];
        }

        service.sanitize = function (data) {
            if (data.model && data.model.custom_fields) {
                    
                var sanitizedCustomFields = [];
                _.forEach(data.model.custom_fields, function (field) {
                    // add line only if type is not empty
                    if (field && field.type) {
                        sanitizedCustomFields.push({
                            key: field.key,
                            type: field.type,
                            value: field.value
                        });
                    }
                });
                data.model.custom_fields = sanitizedCustomFields;
            }
            return true; // also used as a preValidate function
        }

        service.createTemplateCollection = function() {
            var filter = {};
            swif.data.sortOn(filter, 'id', 'ASC');
            return swif.collections.createOrUpdate('custom_fields_templates', 'custom_fields_template', filter);
        };

        // called when a category is selected to retrieve associated templates
        service.getTemplateFromCategory = function (model) {
            // in case of a site category
            if (model.type_id) {
                swif.data.get('site_category', model.type_id[0]).then(category => {
                    model.custom_fields = _.union(model.custom_fields, category.custom_fields)
                });
            }
            // in case of an equipment category
            if (model.categ_id) {
                swif.data.get('equipment_category', model.categ_id[0]).then(category => {
                    model.custom_fields = _.union(model.custom_fields, category.custom_fields)
                });
            }
        }

        return service;
    }

    function customFieldsDirective(swif, openbase) {
        'ngInject';
        var linked = function(scope) {
            scope.choices = {customFieldsTypes: openbase.customfields.getCustomFieldsTypes()};

            // retrieve the "choice" linked to the type of the field
            _.forEach(scope.item, function (field) {
                if (field && field.type) {
                    _.forEach(scope.choices.customFieldsTypes, function (type) {
                        if (type.name === field.type) {
                            field.type = [type.id, type.name];
                        }
                    });
                }
            });

            scope.removeField = openbase.customfields.removeField;
            scope.addField = openbase.customfields.addField;
            scope.onChange = function (currentField) {
                openbase.customfields.onChange(scope, currentField); 
            }
            scope.onTypeChange = openbase.customfields.onTypeChange;
        };
        var directive = swif.panel.create_directive('equipment', undefined, linked);
        directive.scope = {
            form: '<?',
            template: '=?',
        }
        directive.templateUrl = 'partials/openbase/custom_fields_directive.html';
        return directive;
    }
    function customFieldsTemplateController($scope) {
        'ngInject';
        if (!$scope.model.custom_fields) {
            $scope.model.custom_fields = [];
        }

    }

})();